import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { IconMapTrain16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import { ETransportType } from '../../../../types/offer';
import * as styles from './time.css';

const iconByTransportType = {
  transport: <IconMapTrain16 color="icon-secondary-default" />,
  walk: <IconMapWalk16 color="icon-secondary-default" />,
};

export const Time = ({ type, time }: { type: ETransportType; time: string }) => {
  return (
    <div className={styles['time']}>
      <div className={styles['icon']}>{iconByTransportType[type]}</div>
      <UIText1 color="gray60_100">{time}</UIText1>
    </div>
  );
};
